import { useParams } from 'next/navigation';

export const useMarketPlaceProductIdFromUrl = () => {
  const { productId } = useParams();
  return productId as string | undefined;
};
